import { Layout, theme } from 'antd';
import { useWindowSize, useBreakpoint } from '../../../hooks';
import { Resizable } from '../resizable';
import { Block } from '../../block';
import type { CSSProperties, ReactElement } from 'react';
import type { LeftResizableProps } from './types';

/**
 * 需要动态调整宽度时传入resizable 和 name
 * name字段用于向 localstorage 存储页面的宽度
 * @param props
 * @returns
 */
export function Left(props: LeftResizableProps): ReactElement {
  const { height } = useWindowSize();
  const { token } = theme.useToken();
  const { md } = useBreakpoint();
  const style: CSSProperties = {
    backgroundColor: token.colorBgContainer,
    marginRight: md === true ? '4px' : '',
    padding: '12px',
    height: md === true ? height - 52 : 'auto'
  };

  return (
    <>
      <Block if={md === true}>
        <Resizable {...props}>
          <Layout.Sider width={props.resizable ? '100%' : undefined} style={style}>
            {props.children}
          </Layout.Sider>
        </Resizable>
      </Block>
      <Block if={md === false}>
        <div style={style}>
          {props.children}
        </div>
      </Block>
    </>
  );
}
